import { render, staticRenderFns } from "./HomeViewold.vue?vue&type=template&id=dbfec56a&scoped=true"
import script from "./HomeViewold.vue?vue&type=script&lang=js"
export * from "./HomeViewold.vue?vue&type=script&lang=js"
import style0 from "./HomeViewold.vue?vue&type=style&index=0&id=dbfec56a&prod&lang=css"
import style1 from "./HomeViewold.vue?vue&type=style&index=1&id=dbfec56a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbfec56a",
  null
  
)

export default component.exports